import AOS from 'aos';
// import 'aos/dist/aos.css';

import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'dotdotdot-js/dist/dotdotdot.js';

import EmblaCarousel from 'embla-carousel';
import Fade from 'embla-carousel-fade'
import Autoplay from 'embla-carousel-autoplay'
import AutoScroll from 'embla-carousel-auto-scroll'
import { addPrevNextBtnsClickHandlers } from './plugins/EmblaCarouselArrowButtons';
import { addDotBtnsAndClickHandlers } from './plugins/EmblaCarouselDotButton';

window.EmblaCarousel = EmblaCarousel;
window.EmblaPlugins = {
  Fade: Fade,
  Autoplay: Autoplay,
  AutoScroll: AutoScroll,
};
window.addPrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers;
window.addDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers;

AOS.init({
  duration: 1000,
  once: true
});


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var lastScrollTop = 0;
  var dont_animate_nav = false;

  var highlight_submenu_links = $('.header-link-submenu-items');

  function watchNavigationScroll(e) {
    if( dont_animate_nav ) return;

    var st = $(window).scrollTop();

    if (e && e.type && e.type === "scroll") {
      if (st > lastScrollTop) {
        $('body').addClass('scrolled-down');
        $('body').removeClass('scrolled-up');
      }
      else {
        $('body').removeClass('scrolled-down');
        $('body').addClass('scrolled-up');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }

    if (st > 50) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function watchSlickDots() {
    setTimeout(function() {
      $('.slick-dots').each(function() {
        $(this).attr('data-dots-count', $(this).find('li').length);
      });
    }, 300);
  }

  jQuery.extend({
    isValidSelector: function(selector) {
      if (typeof(selector) !== 'string') {
        return false;
      }
      try {
        var $element = $(selector);
      } catch(error) {
        return false;
      }
      return true;
    }
  });

  function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function (e) {
          watchNavigationScroll(e);
        });

        $('#navigation').on('show.bs.collapse', function() {
          dont_animate_nav = true;

          $('body').addClass('nav-on');

          console.log( 'nav show' );

          $('body').removeClass('scrolled').removeClass('scrolled-up').removeClass('scrolled-down');
        });

        $('#navigation').on('shown.bs.collapse', function() {
          dont_animate_nav = false;
        });

        $('#navigation').on('hide.bs.collapse', function() {
          $('body').removeClass('nav-on');

          $('body').removeClass('mobile-highlight-submenu-on');

          highlight_submenu_links.slideUp('fast');

          $('.custom-tab-content, .custom-dropdown-menu, #header .header-link-submenu-items').removeAttr('style');
        });

        $('body').addClass('dom-loaded');

        $(document).on('focus', 'select', function() {
          $(this).closest('div').addClass('active-select');
        });

        $(document).on('blur', 'select', function() {
          $(this).closest('div').removeClass('active-select');
        });

        $(document).on('click', '#navigation .dropdown-toggle', function(e) {
          e.preventDefault();

          if( $('#header .navbar-toggler').is(':visible') ) {
            var sub_menu = $(this).next('.sub-menu-wrap');

            if( sub_menu.length ) {
              if( sub_menu.is(':visible') ) {
                $(this).removeClass('open');
                sub_menu.slideUp('fast');
              }
              else {
                $(this).addClass('open');
                sub_menu.slideDown('fast');
              }
            }
          }
        });

        $('.block-text-images-carousel .embla__viewport').each(function() {
          var t = $(this),
              parent = t.closest('.embla');

          var embla_config = [];

          if( t.attr('data-autoplay-speed') ) {
            embla_config.push( Autoplay({ playOnInit: true, delay: parseInt( t.attr('data-autoplay-speed') ) * 1000 }) );
          }

          var emblaApi = EmblaCarousel(t.get(0), {
            align: 'start',
            loop: true,
            duration: 50
          }, embla_config);

          if( parent.find('.embla__button--prev').length ) {
            var removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
              emblaApi,
              parent.find('.embla__button--prev').get(0),
              parent.find('.embla__button--next').get(0),
            );

            emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
          }

          if( parent.find('.embla__dots').length ) {
            var removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
              emblaApi,
              parent.find('.embla__dots').get(0),
            );

            emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
          }
        });

        $('.locations-carousel .embla__viewport').each(function() {
          var t = $(this),
              parent = t.closest('.embla-parent');

          var embla_config = [];

          if( t.attr('data-autoplay-speed') ) {
            embla_config.push( Autoplay({ playOnInit: true, delay: parseInt( t.attr('data-autoplay-speed') ) * 1000 }) );
          }

          var emblaApi = EmblaCarousel(t.get(0), {
            align: 'start',
            loop: false,
            duration: 50
          }, embla_config);

          if( parent.find('.embla__button--prev').length ) {
            var removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
              emblaApi,
              parent.find('.embla__button--prev').get(0),
              parent.find('.embla__button--next').get(0),
            );

            emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
          }

          if( parent.find('.embla__dots').length ) {
            var removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
              emblaApi,
              parent.find('.embla__dots').get(0),
            );

            emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
          }
        });

        $(document).on('click', '.filter-block .pill-buttons a', function(e) {
          e.preventDefault();

          var section = $(this).closest('.filter-block');

          if( $(this).hasClass('active') ) {
            $(this).removeClass('active');

            section.find('.filter-item').show();
          }
          else {
            $(this).addClass('active').siblings('a').removeClass('active');

            section.find('.filter-item').hide();

            $( $(this).attr('href') ).show();
          }
          
          AOS.refresh();
        });

        $(document).on('click', '.sidebar-menu-toggle', function(e) {
          e.preventDefault();

          if( $('body').hasClass('nav-on') ) {
            $('body').removeClass('nav-on');
            $('.sidebar-menu-toggle').attr('aria-expanded', 'false');
          }
          else {
            $('body').addClass('nav-on');
            $('.sidebar-menu-toggle').attr('aria-expanded', 'true');
          }
        });

        $('.news-filter-form select').on('change', function() {
          if( $(this).val() ) {
            window.location.href = $(this).val();
          }
        });

        $('[data-bs-toggle="tooltip"]').tooltip();
        
        // $('.location-services-tabs [data-bs-toggle="collapse"]').on('click', function() {
        //   var $parent = $(this).closest('.location-services-tabs');
        //   var target = $(this).attr('data-bs-target') || $(this).attr('href');

        //   // Close all open collapse items except the clicked one
        //   $parent.find('.collapse.show').not(target).each(function() {
        //     bootstrap.Collapse.getOrCreateInstance(this).hide();
        //   });

        // });

        $(document).on('show.bs.collapse', '.services-conditions-tabs .tabs-content', function() {
          var t = $(this);
          
          t.siblings('.tabs-content').collapse('hide');
        });

        $('.services-grid .service-article-loop .service-intro-text').dotdotdot({
          truncate: 'letter',
           ellipsis: "..."
        });

        $(document).on('show.bs.modal', '.modal', function() {
          var modal = $(this);

          if( modal.find('video').length > 0 ) {
            modal.find('video').get(0).play();
          }
        });

        $(document).on('hide.bs.modal', '.modal', function() {
          var modal = $(this);

          if( modal.find('video').length > 0 ) {
            modal.find('video').get(0).pause();
          }
        });

        $('.modal').appendTo('body');

        var highlight_submenu_timer = null;

        $(document).on('click', '[href="#schedule-appointment"]', function(e) {
          e.preventDefault();

          $('body').addClass('highlight-submenu-on');

          if( $('.navbar-toggler').is(':visible') ) {
            if( $('body').hasClass('mobile-highlight-submenu-on') ) {
              $('body').removeClass('mobile-highlight-submenu-on');

              highlight_submenu_links.slideUp('fast');
            }
            else {
              $('body').removeClass('scrolled').removeClass('scrolled-up').removeClass('scrolled-down');

              $('body').addClass('mobile-highlight-submenu-on');

              $('#navigation').collapse('show');

              highlight_submenu_links.slideDown('fast');
            }
          }
        });

        $(document).on('click', function(e) {
          if( !$(e.target).closest('.header-link-submenu-items').length && !$(e.target).closest('[href="#schedule-appointment"]').length ) {
            $('body').removeClass('highlight-submenu-on');
          }
        });

        $(document).on('mouseenter', '.header-highlight-link .trigger-button, .header-link-submenu-items', function() {
          clearTimeout( highlight_submenu_timer );

          $('body').addClass('highlight-submenu-on');
        });

        $(document).on('mouseleave', '.header-highlight-link .trigger-button, .header-link-submenu-items', function() {
          highlight_submenu_timer = setTimeout(function() {
            $('body').removeClass('highlight-submenu-on');
          }, 500);
        });

        var submenu_timers = {};

        $('#navigation .menu > li').each(function(i) {
          $(this).attr('data-idx', i);
        });

        $(document).on('mouseenter', '.custom-dropdown-menu .row-tabs a', function(e) {
          e.preventDefault();

          if( $(this).hasClass('.is-active') ) {
            return false;
          }

          $(this).addClass('is-active').closest('.tabs-title').siblings('.tabs-title').find('a').removeClass('is-active');

          var target = $( $(this).attr('data-target') );

          if( target.length ) {
            target.addClass('is-active').siblings().removeClass('is-active');
          }
        });

        var dropdown_timers = {};

        $(document).on('mouseenter', '#navigation .menu > li:has(.custom-dropdown-menu), #navigation .menu .custom-dropdown-menu', function() {
          var t = $(this);
          var id = t.attr('data-idx');

          if( dropdown_timers[ id ] ) {
            clearTimeout( dropdown_timers[ id ] );
          }

          if( !$('.navbar-toggler').is(':visible') ) {
            $('.custom-tab-content, .custom-dropdown-menu, #header .header-link-submenu-items').removeAttr('style');
          }

          t.closest('li').find('> .custom-dropdown-menu').addClass('on');
        });

        $(document).on('mouseleave', '#navigation .menu > li:has(.custom-dropdown-menu), #navigation .menu .custom-dropdown-menu', function() {
          var t = $(this);
          var id = t.closest('li').attr('data-idx');

          dropdown_timers[ id ] = setTimeout(function() {
            t.find('> .custom-dropdown-menu').removeClass('on');
          }, 500);
        });

        $(document).on('click', '.dropdown-toggle, .mobile-link-toggle', function(e) {
          e.preventDefault();

          var t = $(this);

          if( $('.navbar-toggler').is(':visible') ) {
            if( t.closest('.mobile-link-toggle').length ) {
              t = t.closest('.mobile-link-toggle');
            }

            if( $(this).hasClass('on') ) {
              $(this).removeClass('on').find('.dropdown-toggle').removeClass('on');

              $(this).next('.custom-dropdown-menu, .custom-tab-content').slideUp('fast');
            }
            else {
              $(this).addClass('on').find('.dropdown-toggle').addClass('on');

              $(this).next('.custom-dropdown-menu, .custom-tab-content').slideDown('fast');
            }
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
